import { useCallback, useEffect, useRef } from 'preact/hooks';

const DOUBLE_CLICK_DELAY_IN_MILLISECONDS = 300;

export const useDoubleClick = ({
  onClick,
  onDoubleClick,
}: {
  onClick: (e: MouseEvent) => void;
  onDoubleClick: () => void;
}) => {
  const timeoutRef = useRef<number>();
  const clickCountRef = useRef(0);

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();

      clickCountRef.current++;

      if (clickCountRef.current === 1) {
        timeoutRef.current = window.setTimeout(() => {
          clickCountRef.current = 0;

          onClick(e);
        }, DOUBLE_CLICK_DELAY_IN_MILLISECONDS);

        return;
      }

      window.clearTimeout(timeoutRef.current);

      timeoutRef.current = window.setTimeout(() => {
        clickCountRef.current = 0;
      }, DOUBLE_CLICK_DELAY_IN_MILLISECONDS);

      onDoubleClick();
    },
    [onClick, onDoubleClick]
  );

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return { handleClick };
};
